import type {
  SidebarRenderType,
} from './types';

export const MENU_DEFAULT: SidebarRenderType = 'MENU_DEFAULT';
export const MENU_COLLAPSED: SidebarRenderType = 'MENU_COLLAPSED';
export const MENU_HOVER: SidebarRenderType = 'MENU_HOVER';
